import { SmartTable } from '../../../../../../components/smart-table/smart-table.model';

export class Controller {

    /** @ngInject */
    constructor($state, UserLabelsService, Alert) {
        this.$state = $state;
        this.UserLabelsService = UserLabelsService;
        this.Alert = Alert;
		this.queryLabelIds=(labelInRow)=> {
        	return labelInRow.id !== this.userLabelId;
    	}
    }

    $onInit() {
        if (!this.users.length) {
            this.$state.go('^', {}, {location: 'replace'})
        }

        this.st = new SmartTable();

    }

    move() {
	const companyId=this.companyId;
		const labelId=this.userLabelId;
        const userIds = this.users.map(({id}) => id);
		var toLabelId=this.st.selectedIds[0];
        this.isSaving = true;
        this.UserLabelsService
            .moveCompanyUsersToLabel({companyId, labelId, toLabelId}, userIds).$promise
            .then(() => this.$state.go('^', {userLabelId: this.st.selectedIds[0]}, {reload: '^.^'}))
            .then(() => {
                const key = 'company.user-directories.saaspass-users.user-labels.users.move.moved';
                const variables = {labelName: this.st.selectedItems[0].labelName};
                this.Alert('success', key, variables);
            })
            .finally(() => this.isSaving = false)
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/saaspass-users/user-labels/move/move-users-to-label.controller.js